import React, { Component } from 'react';

function HomeBanner() {
  return (
    <div className="home-banner">
      <img src="/images/logged_in_banner.jpg" alt="home-banner" />
    </div>
  );
}

export default HomeBanner;

// export default class HomeBanner extends Component {
//   static propTypes = {};

//   render() {
//     return (
//       <div className="home-banner">
//         <img src="/images/logged_in_banner.png" alt="home-banner" />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/my-account/HomeBanner/HomeBanner.js